<template lang="">
	<div style="display:flex; margin:3px;">
		<div v-if="label">
			<h4 style="width:150px; ">{{ label }}</h4>
		</div>
		<el-input :placeholder="placeholder" :value="value" @input="onchange" :label="label" />
	</div>
</template>

<script>
export default {
	props: ['label', 'placeholder', 'value', 'onchange'],
	methods: {
		// printStatus: printStatus
	}
};
</script>
<style lang=""></style>
